import { UserCircle, Cpu } from 'lucide-react';
import type { HubSection } from '@/components/layout/HubLayout';

export const AGENTS_HUB_SECTIONS: HubSection[] = [
  {
    id: 'personas',
    label: 'Personas',
    icon: UserCircle,
    description: 'Reusable agent personalities and launch defaults.',
  },
  {
    id: 'models',
    label: 'Agent Models',
    icon: Cpu,
    description: 'Enable agent types, providers, and Launch dialog defaults.',
    permission: 'org:read',
  },
];

export const DEFAULT_AGENTS_HUB_SECTION = 'personas';

export function agentsHubSection(id: string): HubSection | undefined {
  return AGENTS_HUB_SECTIONS.find((s) => s.id === id);
}
